import React from 'react'
import { UserProfilePageBodyProps } from './UserProfilePageBody.types'
import styles from './UserProfilePageBody.module.scss'
import cl from 'classnames'
import { inject } from 'mobx-react'
import { GENERAL_STORE, INVITE_USER_STORE, USER_PROFILE_STORE } from 'store'
import { H2, PageHeader, SectionContainer } from 'components/shared'
import { IconUserManagement } from 'assets'
import { User } from 'utilities'
import { UserInfoSection } from '../UserInfoSection'
import { UserProjectsSection } from '../UserProjectsSection'
import { GdprSection } from '../GdprSection/GdprSection'
import { ActionHistoryTable } from 'components'
import { observer } from 'mobx-react-lite'

const UserProfilePageBodyComponent = (props: UserProfilePageBodyProps) => {
  const {
    className,
    style,
    [USER_PROFILE_STORE]: {
      fullName,
      canAssignProjects,
      hasAssignedProjects,
      userId,
      assignProject
    },
    [INVITE_USER_STORE]: {
      projectOptions
    },
    [GENERAL_STORE]: {
      push
    },
    editAs = 'self'
  } = props

  if (!userId) return null

  return (
    <div
      className={cl(styles.pageContainer, styles.scrollable, className)}
      style={ { ...style, overflowX: 'hidden' } }
    >
      <PageHeader
        navSegments={[
          {
            label: 'User management',
            icon: IconUserManagement,
            onClick: () => push('/user-management'),
            iconProps: { viewBox: '0 0 22 22' }
          },
          {
            label: fullName
          }
        ]}
      />

      <UserInfoSection editAs={editAs} />

      {editAs === 'parent' && User.isAdmin() && <GdprSection />}
      {editAs === 'parent' && !User.isAdmin() && (
        <SectionContainer style={{ marginTop: 12 }}>
          <p style={{ margin: 0, fontSize: 13, opacity: 0.8 }}>
            GDPR (Super Admin) section is only visible when logged in with SUPER_ADMIN role.
          </p>
        </SectionContainer>
      )}

      {canAssignProjects && (
        <UserProjectsSection
          hasAssignedProjects={hasAssignedProjects}
          assignProject={assignProject}
          projectOptions={projectOptions}
        />
      )}

      <SectionContainer style={{ marginTop: 20 }}>
        <H2>Action history</H2>
        <ActionHistoryTable
          userId={userId}
          hidePaginationInfo
          paginationProps={{ size: 5 }}
          tableContainerProps={{
            noBoxShadow: true,
            style: {
              marginTop: 20,
              overflowX: 'auto'
            }
          }}
          // tableBodyLineProps={{
          //   // className: styles.tableBody,
          //   containerProps: {
          //     className: styles.tableBody
          //   }
          // }}
          // viewAllButtonContainerProps={{
          //   className: styles.tableBody
          // }}
          viewAllButtonProps={{
            onClick: () => push('/action-history')
          }}
          isDashboardVersion={true}
        />
      </SectionContainer>
    </div>
  )
}

const UserProfilePageBody = inject(
  USER_PROFILE_STORE,
  INVITE_USER_STORE,
  GENERAL_STORE
)(observer(UserProfilePageBodyComponent))
export { UserProfilePageBody }
